import { call, put, takeLatest, all } from 'redux-saga/effects';
import HeroAccountAPI from 'api-services/HeroAccountApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
// import isCaregiverMode from '../utils/isCaregiverMode';
import { GET_USER_FLAGS } from './actionTypes';
import { doneGettingUserFlags, errorGettingUserFlags } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* getUserFlagsCall(constAccessParams) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    // FIXME this is WRONG - `newAccessParams` doesn't have `status` prop which
    // `isCaregiverMode` fn tries to check... however, until caregiver flow is
    // actually supported in web app it's fine to hardcode the value to `false`
    const isCaregiver = false;
    // const isCaregiver = isCaregiverMode(newAccessParams);
    const [result, heroOfflineResults] = yield all([
        call(HeroAccountAPI.getUserFlags, newAccessParams),
        ...(isCaregiver ? [call(HeroAccountAPI.checkHeroOffline, newAccessParams)] : [])
    ]);
    if (isSuccessResponse(result)) {
        yield put(doneGettingUserFlags(heroOfflineResults && heroOfflineResults.statusCode === 0
            ? Object.assign(Object.assign({}, result.data), heroOfflineResults.data) : result.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(errorGettingUserFlags(result));
    }
    return result;
}
export function* watchGetUserFlagsCalls(constAccessParams) {
    yield takeLatest(GET_USER_FLAGS, getUserFlagsCall, constAccessParams);
}
//# sourceMappingURL=saga.js.map